import queryString from 'query-string';
import { takeLatest, call, put, select, take } from 'redux-saga/effects';

import { passwordResetRequired } from 'modules/auth/login/data/actions';
import { DISCOVER_NEXT } from 'modules/auth/login/data/constants';
import { loginWithToken } from 'modules/auth/login/data/sagas';

import authService from 'services/authService';

import { PAGE_REQUEST } from 'store/app/actions';
import { getHomePage } from 'store/app/selectors';
import { getIsLoggedIn } from 'store/session/selectors';

import history from 'utils/browserHistory';
import { getErrorMessage } from 'utils/stringUtils';

import { types, twoFactorLogin } from './actions';

export default function* root() {
  yield takeLatest(
    types.INIT_TWO_FACTOR_AUTHENTICATION,
    initTwoFactorAuthentication,
  );
}

export function* redirectIfLoggedIn(loc) {
  const isLoggedIn = yield select(getIsLoggedIn);
  if (isLoggedIn) {
    const next = queryString.parse(loc.location.search).next;
    next ? history.push(next) : history.push(yield select(getHomePage));
  }
}

function* initTwoFactorAuthentication(action) {
  const { username, password, next } = action.payload;
  yield takeLatest(
    types.LOGIN_TWO_FACTOR_REQUEST,
    twoFactorLoginRequest,
    username,
    password,
    next,
  );
}

export function* twoFactorLoginRequest(username, password, next, action) {
  try {
    const { token } = action.payload;
    const nextUrl = decodeURIComponent(next || '');
    const response = yield call(authService.twoFactorLogin, {
      username,
      password,
      token,
      next: nextUrl || '/',
    });
    // The user was migrated to Authentik after the password step (for
    // example, by a login elsewhere), so they must sign in there.
    if (response.next === DISCOVER_NEXT.OIDC) {
      window.location.replace(response.oidcUrl);
      return;
    }
    // The code checked out, which migrated a legacy 2FA user to Authentik,
    // but Authentik rejected their password and emailed them a reset link.
    // The notice lives on the login page, whose state resets on navigation,
    // so set it once the page has loaded.
    if (response.passwordResetRequired) {
      history.push('/login');
      yield take(PAGE_REQUEST);
      yield put(passwordResetRequired());
      return;
    }
    if (response.token) {
      yield put(twoFactorLogin.success());
      yield call(loginWithToken, response.token, nextUrl);
    }
  } catch (error) {
    yield put(
      twoFactorLogin.error({ error: getErrorMessage(error, 'Unknown error') }),
    );
  }
}
